import { atom } from "jotai";

export const modalDataAtom= atom<{[id: string]: any}>({});
